export const ErrorMessages = {
    PipeLineStageMaxLimit: 'Maximum 15 stages are allowed in a pipeline',
    UnreadConversationSelected: 'Please select read converstion only.',
 };

 export const InfoMessages = {
    ArchiveConversation: 'You can no longer exchange messages in an archived conversation.',
    FacebookMessageOutside7Days: 'Your message cannot be sent because it is outside Facebook\'s 7-day response window. This restriction is part of Facebook\'s Messenger policy. To continue the conversation, please respond within 7 days of the user\'s last message.',
 };

